"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palaia": {
    "48590b81": [{
      "hkey": "9d2b0f4d",
      "slug": "alica-baccanella-montanelli",
      "name": "Alica-Baccanella-Montanelli",
      "primary": true,
      "skipSearch": false
    }],
    "alica": [{
      "hkey": "9d2b0f4d",
      "slug": "alica-baccanella-montanelli",
      "name": "Alica-Baccanella-Montanelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "palaia"
    }],
    "99597db3": [{
      "hkey": "9d2b0f4d",
      "slug": "alica-baccanella-montanelli",
      "name": "Alica-Baccanella-Montanelli",
      "primary": true,
      "skipSearch": false
    }],
    "baccanella": [{
      "hkey": "9d2b0f4d",
      "slug": "alica-baccanella-montanelli",
      "name": "Alica-Baccanella-Montanelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "73382a57": [{
      "hkey": "faa6dd9a",
      "slug": "palaia",
      "name": "Palaia",
      "primary": true,
      "skipSearch": false
    }],
    "chiecinella": [{
      "hkey": "faa6dd9a",
      "slug": "palaia",
      "name": "Palaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9fdf9b77": [{
      "hkey": "3062c835",
      "slug": "montechiari-montacchita",
      "name": "Montechiari-Montacchita",
      "primary": true,
      "skipSearch": false
    }],
    "montacchita": [{
      "hkey": "3062c835",
      "slug": "montechiari-montacchita",
      "name": "Montechiari-Montacchita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "palaia"
    }],
    "808d3a16": [{
      "hkey": "9d2b0f4d",
      "slug": "alica-baccanella-montanelli",
      "name": "Alica-Baccanella-Montanelli",
      "primary": true,
      "skipSearch": false
    }],
    "montanelli": [{
      "hkey": "9d2b0f4d",
      "slug": "alica-baccanella-montanelli",
      "name": "Alica-Baccanella-Montanelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "palaia"
    }],
    "e1cdd9e8": [{
      "hkey": "3062c835",
      "slug": "montechiari-montacchita",
      "name": "Montechiari-Montacchita",
      "primary": true,
      "skipSearch": false
    }],
    "montechiari": [{
      "hkey": "3062c835",
      "slug": "montechiari-montacchita",
      "name": "Montechiari-Montacchita",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b37288cc": [{
      "hkey": "faa6dd9a",
      "slug": "palaia",
      "name": "Palaia",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "faa6dd9a",
      "slug": "palaia",
      "name": "Palaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "58f8af82": [{
      "hkey": "faa6dd9a",
      "slug": "palaia",
      "name": "Palaia",
      "primary": true,
      "skipSearch": false
    }],
    "toiano": [{
      "hkey": "faa6dd9a",
      "slug": "palaia",
      "name": "Palaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1ca30de1": [{
      "hkey": "faa6dd9a",
      "slug": "palaia",
      "name": "Palaia",
      "primary": true,
      "skipSearch": false
    }],
    "usigliano": [{
      "hkey": "faa6dd9a",
      "slug": "palaia",
      "name": "Palaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;